// export * from "./multi-end";
export * from "./element";
export * from "./action";
export * from "./redux-factory";
export * from "./http-request";
console.log("process.env.TEST_ENV:", process.env);
if (process.env.TEST_ENV === "h5") {
    module.exports = require("./wechat-web");
}
// export * from "./wechat-web";
export * from "./wechat-app";
